import React, { useEffect, useState } from "react";
import FHIR from "fhirclient";

import {
  Box,
  Paper,
  Text,
  createStyles,
  Button,
  Avatar,
  Image,
  Accordion,
  Center,
  Modal,
  Flex,
  Title,
  Group,
  TextInput,
  Overlay,
  Anchor,
} from "@mantine/core";
import { Summary } from "../AIRecipes/SummaryAi";
import heartSvg from "../../assets/img/heart.svg";
import aiSvg from "../../assets/img/ai.svg";
import losSvg from "../../assets/img/los.svg";
import hospitalSvg from "../../assets/img/hospitalAI.svg";
import symptomsSvg from "../../assets/img/symptoms-check-icon.svg";
import {
  IconMail,
  IconPlus,
  IconSparkles,
  IconWorld, // Import the cross icon
} from "@tabler/icons-react";
import Logo from "../../assets/img/healthConnectLogo1.svg";
import { useLocation, useParams } from "react-router-dom";
import { Container, useMedplum } from "@medplum/react";
import { getPatientName } from "../Eligibility/EligibiltyService";
import { useMediaQuery } from "@mantine/hooks";

import {
  extractNoteTexts,
  formatAiSummary,
  formatCardioSummary,
  formatLosPrediction,
  formatReadmissionPrediction,
  getAiNameDisplay,
  getSymptoms,
  updateSummaryWithRelevantFields,
} from "./Service";
import { log } from "console";
import Layout from "./Layout";
import { PatientDetail } from "../Patient/PatientDetails/Details";
import { PatientDetails } from "../questionnare/Card";
import { getAddress } from "../questionnare/Service";
import Card from "../AIRecipes/Card";
import aiStasSvg from "../../assets/img/stars.svg";
import aiAnimation from "../../assets/img/aiSummaryAnimation.gif";
import BorderFrame from "./Border";
import { showNotification } from "@mantine/notifications";
import { cardioVascularData, defaultSummaryBody, HealthConnectApps, losPrediction, patientReadmissonPrediction, sampleData, summary, symptomPrediction } from "./Constant";
import { summarizeDisease } from "../AIRecipes/aiService";
import patientSvg from "../../assets/img/PatientNotFOund.svg";

const useStyles = createStyles((theme) => ({
  paper: {
    borderRadius: theme.radius.md,
    // padding: "8px",
    background: "#f5f5f5",
    
    height: "91vh",
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  content: {
    display: "flex",
    gap: "20px",
    justifyContent: "center",
    height: "100vh",
  },
  
  hidden: {
    display: "none",
  },
  logo: {
    fontSize: theme.fontSizes.xl,
    fontWeight: 700,
    color: theme.colors.blue[6],
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
  },
  summaryText: {
    color: theme.colors.dark[6],
    fontSize: theme.fontSizes.md,
    lineHeight: 1.6,
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  rightSection: {
    // flex: "0 0 70%",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    overflowY: "auto",
    overflowX: "hidden",
    scrollBehavior: "smooth",
    "&::-webkit-scrollbar": {
      width: "1px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#C0C0C0",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#555",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
  },
  patientDetails: {
    // padding: "25px",
    backgroundColor: theme.white,
    borderRadius: theme.radius.md,
    // boxShadow: theme.shadows.md,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "20px",
  },
  patientInfo: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
  },
  patientItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: theme.fontSizes.md,
    color: theme.colors.dark[7],
  },
  section: {
    padding: "25px",
    backgroundColor: theme.white,
    borderRadius: theme.radius.md,
    height: "100%",
    boxShadow: theme.shadows.md,
    flex: 1,
    transition: "transform 0.2s ease",
    "&:hover": {
      transform: "scale(1.02)",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "25px",
  },
  button: {
    background: "linear-gradient(135deg, #6a11cb, #2575fc)",
    border: "none",
    color: theme.white,
    fontWeight: 600,
    padding: "10px 20px",
    borderRadius: theme.radius.sm,
    cursor: "pointer",
    transition: "background 0.2s ease",
    "&:hover": {
      background: "linear-gradient(135deg, #2575fc, #6a11cb)",
    },
  },
  boxFirst: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px",
    minHeight: "300px",
    // width: "100%",
    height: "100%",
    gap: "32px",

    justifyContent: "center",
    // alignItems:"flex-end"
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    backgroundColor: theme.colors.gray[0],
    "&:hover": {
      backgroundColor: theme.colors.gray[2],
    },
  },
  select: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
    color: "#262930",
  },
}));
interface embedProps {
  aiName?: string;
}

interface Observation {
  resource: {
    code: { text: string };
    valueQuantity?: { value: number; unit: string };
  };
}

export const EmbedUI: React.FC<embedProps> = ({ aiName }) => {
  const initSummaryTags = {
    diseases: [] as string[],
    drugs: [] as string[],
    observations: [] as string[],
  };
  const { classes } = useStyles();
  const [clientData, setClientData] = useState<any>([]);
  const medplum = useMedplum();
  const url = window.location.pathname;

  const { code } = useParams();
    const isRetinaScreen = useMediaQuery(
      "(min-width: 2560px) and (min-resolution: 2dppx)"
    );
     const isSmallScreen = useMediaQuery("(max-width: 768px)");
     const isMediumScreen = useMediaQuery("(max-width: 1024px)");
     const isLargeScreen = useMediaQuery("(max-width: 1400px)");


  const [patient, setPatient] = useState<any>();
  const [conditions, setConditions] = useState<any>([]);
  const [observations, setObservations] = useState<any>([]);
  const [coverage, setCoverage] = useState<any>([]);
  const [height, setHeight] = useState<any>([]);
  const [weight, setWeight] = useState<any>([]);
  const [heartRate, setHeartRate] = useState<any>([]);
  const [bp, setBp] = useState<any>([]);
  const [showBorder,setShowBorder]=useState<boolean>(false)

  const [selectedSymptom, setSelectedSymptoms] = useState<string | undefined>();
  const [fetchingUserDetails, setFetchingUserDetails] =
    useState<boolean>(false);
  const [procedures, setProcedures] = useState<any>([]);
  const [showAi,setShowAi]=useState<any>()
  const [encounter, setEncouner] = useState<any>([]);
  const [encounterDate, setEncounterDate] = useState<any>("");
  const [encounterSummary, setEncounterSummary] = useState<any>("");
  const [aiResponse, setAiResponse] = useState<string>("Please try again...");
  const [input, setInput] = useState<any>([]);
  const [generating, setGenerating] = useState<boolean>(false);
  const [showAiResponse, setShowAiResponse] = useState<boolean>(false);
  const [login, setLogin] = useState<boolean>(false);

  const [cardioRed, setCardioRed] = useState<boolean | boolean>(false);
  const [summaryTags, setSummaryTags] = useState(initSummaryTags);
  const [cardioPrediction, setCardioPrediction] = useState<
    string | undefined
  >();
  const [showSumm, setShowSumm] = useState<boolean>(true);
  const [body, setBody] = useState<any>();
    const handleCheckboxChange = (isChecked:any) => {
      
      setShowBorder(isChecked);
      
    };

  const getSummaries = async () => {
    try {
      let summaryDetails = null;

      if (login === false) {
        setGenerating(false);
        showNotification({
          color: "red",
          message: "Failed! Please try again",
          autoClose: true,
        });

        return;
      } else {
        if (aiName === "cardio") {
          try {
            setGenerating(true);
            setShowAiResponse(true);
            setShowAi(2)

            setShowSumm(true);
            summaryDetails = await formatCardioSummary(
              medplum,
              observations,
              patient,
              setAiResponse,
              setCardioPrediction,
              setSummaryTags,
              setCardioRed
            );
            setInput(summaryDetails?.input?.[0]);
          } catch (error) {
            setGenerating(false);
            showNotification({
              color: "red",
              message: "Failed!",
              autoClose: true,
            });
          } finally {
            setGenerating(false);
          }
        } else if (aiName === "reAdmission") {
          setGenerating(true);
          setShowAiResponse(true);
                      setShowAi(2);


          setShowSumm(true);
          summaryDetails = await formatReadmissionPrediction(
            medplum,
            patient,
            encounter[0]?.resource,

            setAiResponse,
            setCardioPrediction,
            setSummaryTags,
            setCardioRed
          );
          setGenerating(false);
                      setShowAi(2);


          setInput(summaryDetails?.input);
        } else if (aiName === "los") {
          setGenerating(true);

          setShowAiResponse(true);
                      setShowAi(2);


          summaryDetails = await formatLosPrediction(
            medplum,
            patient,
            encounter,
            conditions,
            coverage,
            procedures,
            setAiResponse,
            setCardioPrediction,
            setSummaryTags,
            setCardioRed
          );
          setGenerating(false);

          // const subHeading = formatDataForSubheading(summaryDetails?.input);

          setInput(summaryDetails?.input);
        } else {
          setGenerating(true);
          setShowAiResponse(true);
                      setShowAi(1);


          setShowSumm(true);
          let summaryDetailsForAiSummary = null;

          summaryDetailsForAiSummary = await formatAiSummary(
            medplum,
            body,
            setAiResponse,
            setCardioPrediction,
            setSummaryTags,
            setCardioRed
          );
          setGenerating(false);
          setInput(summaryDetailsForAiSummary?.input?.[0]?.[0]);
        }
      }
    } catch (error) {
      setGenerating(false);
      showNotification({
        color: "red",
        message: "Failed!",
        autoClose: true,
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setFetchingUserDetails(true);
        const client = await FHIR.oauth2.ready();

        // Get the patient data
        const patientData = await client.patient.read<any>();

        setPatient(patientData);

        const conditionsResponse = await client.request<{ entry: any }>(
          `Condition?patient=${client.patient.id}&_count=20`
        );
        const symptoms = extractNoteTexts(conditionsResponse.entry);

        setSelectedSymptoms(symptoms);

        setConditions(conditionsResponse.entry || []);

        // Get the latest observations
        const observationsResponse = await client.request<{
          entry: Observation[];
        }>(`Observation?patient=${client.patient.id}&_sort=-date&_count=2`);
        setObservations(observationsResponse.entry || []);
        //get the height ,eight ,heart rate,bp
        const heightForSymptoms = await client.request<{
          entry: Observation[];
        }>(
          `Observation?&code=8302-2&patient=${client.patient.id}&_sort=-date&_count=1`
        );
        setHeight(heightForSymptoms.entry || []);

        const weightForSymptoms = await client.request<{
          entry: Observation[];
        }>(
          `Observation?&code=29463-7&patient=${client.patient.id}&_sort=-date&_count=1`
        );
        setWeight(weightForSymptoms.entry || []);
        const heartRateForSymptoms = await client.request<{
          entry: Observation[];
        }>(
          `Observation?&code=8867-4&patient=${client.patient.id}&_sort=-date&_count=1`
        );
        setHeartRate(heartRateForSymptoms.entry || []);
        const bloodPressureForSymptoms = await client.request<{
          entry: Observation[];
        }>(
          `Observation?&code=85354-9&patient=${client.patient.id}&_sort=-date&_count=1`
        );
        setBp(bloodPressureForSymptoms.entry || []);
        //get the latest coverage

        // const coverageResponse = await client.request<{
        //   entry: Observation[];
        // }>(`Coverage?patient=${client.patient.id}&_sort=-date&_count=2`);
        // setCoverage(coverageResponse?.entry || []);

        // Get the latest encounter
        const procedureResponse = await client.request<{
          entry: Observation[];
        }>(`Procedure?patient=${client.patient.id}&_sort=-date&_count=2`);
        setProcedures(procedureResponse.entry || []);

        const encountersResponse = await client.request<{ entry: any }>(
          `/Encounter?patient=${client.patient.id}&_count=1`
        );
        setEncouner(encountersResponse?.entry);

        if (encountersResponse.entry && encountersResponse.entry.length > 0) {
          const encounter = encountersResponse.entry[0].resource;
          setEncounterDate(encounter.period?.start || "Unknown Date");

          setEncounterSummary(
            encounter?.reasonCode?.[0]?.text || "No summary available."
          );
        } else {
          setEncounterDate("No encounter found");
          setEncounterSummary("");
        }
        setFetchingUserDetails(false);
      } catch (error) {
        setFetchingUserDetails(false);
        showNotification({
          color: "red",
          message: `Error Fetching data: ${error}`,
          autoClose: true,
        });
        console.error("Error fetching FHIR data", error);
      }
    };
    fetchData();
    const body = updateSummaryWithRelevantFields(
      defaultSummaryBody,
      patient,
      conditions,

      observations,
      encounterSummary
    );
  }, []);

  useEffect(() => {
    const body = updateSummaryWithRelevantFields(
      defaultSummaryBody,
      patient,
      conditions,

      observations,
      encounterSummary
    );
    setBody(body);
  }, [patient]);
  useEffect(() => {
    loginWithIdandSecret();
  }, []);

  const loginWithIdandSecret = async () => {
    try {
      const decodedQuery = decodeURIComponent(code as string);

      const decodeQueryStringWithData = atob(decodedQuery);

      const queryParamss = decodeQueryStringWithData.split(",");
      setClientData(queryParamss);
      const id = queryParamss[0];
      const secret = queryParamss[1];

      const login = await medplum.startClientLogin(id, secret);
      if (login) {
        setLogin(true);
        return true;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const generateSymptoms = () => {
    setAiResponse("Generating...");
    setGenerating(true);
    setShowAiResponse(true);

    setShowSumm(true);

    getSymptoms(
      medplum,
      patient,
      conditions,
      selectedSymptom,
      height,
      weight,
      heartRate,
      bp
    ).then((res) => {
      setInput(res?.input?.[0]);
      const diseasesResponse = summarizeDisease(
        res,
        getPatientName(patient?.name) ?? ""
      );

      setAiResponse(diseasesResponse ?? "please try again");
      setGenerating(false);

      setSummaryTags({
        diseases: ["fever"] ,
        drugs: ["Paracetamol"] ,
        observations: ["No significant findings"] ,
      });
    });
  };

  return (
    <BorderFrame showBorder={showBorder}>
      <Paper className={classes.paper}>
        <Box className={classes.content}>
          <Box sx={{ height: showBorder ? "93vh" : "83vh" }}>
            <Layout
              info={
                aiName === "summary"
                  ? HealthConnectApps.AI_SUMMARY.description
                  : aiName === "cardio"
                  ? HealthConnectApps.AI_CARDIOVASCULAR.description
                  : aiName === "symptom"
                  ? HealthConnectApps.AI_SYMPTOM_ANALYZER.description
                  : aiName === "los"
                  ? HealthConnectApps.AI_LENGTH_OF_STAY.description
                  : aiName === "reAdmission"
                  ? HealthConnectApps.AI_READMISSION_RISK.description
                  : ""
              }
              data={
                aiName === "summary"
                  ? summary
                  : aiName === "cardio"
                  ? cardioVascularData
                  : aiName === "symptom"
                  ? symptomPrediction
                  : aiName === "los"
                  ? losPrediction
                  : aiName === "reAdmission"
                  ? patientReadmissonPrediction
                  : sampleData
              }
              checked={showBorder}
              showBorderFunction={handleCheckboxChange}
              title={
                aiName === "summary"
                  ? "AI Medical Summary"
                  : aiName === "los"
                  ? "AI Length Of Stay Prediction"
                  : aiName === "cardio"
                  ? "AI Cardiovascular Risk Prediction"
                  : aiName === "symptom"
                  ? "AI Medical Symptoms"
                  : aiName === "reAdmission"
                  ? "AI Readmission Prediction"
                  : "HealthConnect AI"
              }
            />
          </Box>

          <Box
            className={`${classes.rightSection} `}
            sx={{
              maxHeight: showBorder ? "93vh" : "83vh",
              flex: isSmallScreen
                ? "0 0 100%"
                : isMediumScreen
                ? "0 0 80%"
                : isLargeScreen
                ? "0 0 59%"
                : "0 0 60%",
              transform: isRetinaScreen ? "scale(1)" : "none", // Adjust for Retina displays
            }}
            // sx={{ flex: !isCardVisible ? "0 0 100%" : "0 0 70%" }}
          >
            <Box className={classes.patientDetails}>
              <PatientDetails
                name={getPatientName(patient?.name)}
                dob={patient?.birthDate ?? "--"}
                mobile={patient?.telecom?.[0]?.value}
                address={"--"}
                email={patient?.email ?? "--"}
                gender={patient?.gender ?? "--"}
                moreDetails={true}
                city={patient?.address?.[0]?.city}
                country={patient?.address?.[0]?.country}
                age={
                  patient?.birthDate
                    ? new Date().getFullYear() -
                      new Date(patient.birthDate).getFullYear() -
                      (new Date().setFullYear(0) <
                      new Date(patient.birthDate).setFullYear(0)
                        ? 1
                        : 0)
                    : "--"
                }
              />
            </Box>

            <Box
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                // boxShadow: theme.shadows.md,
              }}
              w={"100%"}
            >
              <Accordion
                chevron={<IconPlus size="1rem" />}
                styles={{
                  chevron: {
                    "&[data-rotate]": {
                      transform: "rotate(45deg)",
                    },
                  },
                }}
              >
                {" "}
                <Accordion.Item value="customization">
                  <Accordion.Control
                    disabled={aiResponse === "Please try again..."}
                  >
                    <Text
                      sx={{
                        fontWeight: 600,
                        fontSize: "15px",
                        lineHeight: "30px",
                        color: "#262930",
                      }}
                    >
                      {" "}
                      Patient Data
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel
                    sx={{ marginLeft: "-12px", marginRight: "-12px" }}
                  >
                    <Card showAi={showAi} data={input || []} />
                  </Accordion.Panel>
                </Accordion.Item>
              </Accordion>
            </Box>
            <Box h={"100%"}>
              <Text
                sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "24px",
                  color: "#262930",
                  paddingBottom: "8px",
                }}
              >
                {aiName === "summary"
                  ? "Patient Medical Summary"
                  : aiName === "los"
                  ? "Patient Length Of Stay Prediction"
                  : aiName === "cardio"
                  ? "Patient Cardiovascular Risk Prediction"
                  : aiName === "symptom"
                  ? "Patient Symptoms"
                  : aiName === "reAdmission"
                  ? " Patient Readmission Prediction"
                  : "HealthConnect Summary"}{" "}
              </Text>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: showAiResponse ? "flex-start" : "center",
                  gap: "20px",
                  width: "100%",
                  height: "95%",
                  backgroundColor: "white",
                  borderRadius: "8px",
                  padding: "24px",
                }}
              >
                {showAiResponse ? (
                  <Summary
                    regenerate={
                      aiName === "symptom" ? generateSymptoms : getSummaries
                    }
                    Embed={true}
                    text={aiResponse}
                    cardiovascular={cardioPrediction}
                    diseases={summaryTags?.diseases}
                    drugs={summaryTags?.drugs}
                    observations={summaryTags?.observations}
                    cardioRed={cardioRed}
                    aiButtonName={""}
                  />
                ) : (
                  <>
                    {aiName === "symptom" ? (
                      <Box sx={{ width: "70%" }}>
                        <Box
                          mt="md"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            gap: "16px",
                          }}
                        >
                          <Box
                            sx={{ display: "flex", justifyContent: "center" }}
                          >
                            <Image src={patientSvg} width={"200px"} />
                          </Box>
                          <Box w={"100%%"}>
                            <Text className={classes.select}>
                              Patient Symptom's{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Text>
                            <TextInput
                              size="lg"
                              radius="md"
                              mt="sm"
                              placeholder="Enter a symptom"
                              value={selectedSymptom}
                              onChange={(event) =>
                                setSelectedSymptoms(event.currentTarget.value)
                              }
                            />
                          </Box>

                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <Button
                              variant="outline"
                              size="lg"
                              radius={"md"}
                              disabled={
                                !selectedSymptom ||
                                aiResponse === "Generating..."
                              }
                              onClick={generateSymptoms}
                            >
                              {" "}
                              <IconSparkles style={{ marginRight: "10px" }} />
                              Generate
                            </Button>
                          </Box>
                        </Box>
                      </Box>
                    ) : (
                      <>
                        <Box>
                          <Image width={"200px"} src={aiStasSvg} />
                        </Box>
                        <Box>
                          <Text
                            color="#586171"
                            fw={500}
                            lh={"20px"}
                            sx={{ fontSize: "14px" }}
                          >
                            Generate {getAiNameDisplay(aiName as any)} by
                            clicking below.
                          </Text>
                        </Box>
                        <Box>
                          <Button
                            bgr={"#1B75BC"}
                            disabled={fetchingUserDetails}
                            onClick={getSummaries}
                          >
                            <IconSparkles style={{ marginRight: "10px" }} />{" "}
                            {fetchingUserDetails
                              ? "Fetching patient details..."
                              : "Generate"}
                          </Button>
                        </Box>
                      </>
                    )}
                  </>
                )}

                {/* </Box> */}
                {/* </Box> */}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          style={{
            padding: "1rem 0",
            borderTop: "1px solid #eaeaea",
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-evenly",
            backgroundColor: "rgb(243 250 255)",
          }}
        >
          <Group spacing="xs">
            <IconMail color="#228be6" size={20} />
            <Text size="sm" color="blue">
              <Anchor
                href="mailto:healthconnect@mindbowser.com"
                target="_blank"
              >
                healthconnect@mindbowser.com
              </Anchor>
            </Text>
          </Group>

          <Group spacing="xs">
            <IconWorld color="#228be6" size={20} />
            <Text
              sx={{
                cursor: "pointer",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
              size="sm"
              color="blue"
              onClick={() => {
                window.open("https://healthconnect.mindbowser.com/");
              }}
            >
              healthconnect.mindbowser.com
            </Text>
          </Group>

          <Text size="sm" color="blue">
            © 2024 Mindbowser Inc. All rights reserved.
          </Text>
        </Box>

        <Modal
          opened={generating}
          onClose={() => setGenerating(false)}
          size={"lg"}
          withCloseButton={false}
          centered
          closeOnClickOutside={false}
          closeOnEscape={false}
        >
          <Flex
            mih={250}
            justify="center"
            align="center"
            direction={"column"}
            gap={"20px"}
          >
            <img src={aiAnimation} alt="" />
            <Title fw={600} lh={"30px"} size="lg">
              Please wait, we're generating patient's{" "}
              {getAiNameDisplay(aiName as any, true)}
            </Title>
          </Flex>
        </Modal>
      </Paper>
    </BorderFrame>
  );
};
